<template>
  <div v-if="project" class="project">
    <div class="intro">
      <Hero
        partners="Miriam Steckl, Stefanie Lüthen"
        project="Re-designing shoplifting"
        organisation="UoAS Potsdam"
        :heroBackground="project.data.preview[0].background.url"
        :heroLogo="project.data.preview[0].logo.url"
        heroType="Using Service Design to build Services for the Police Department of Brandenburg"
        heroTitle="Using Service Design to build Services for the Police Department of Brandenburg"
        :layout="project.data.position"
        :size="project.data.sizemodifier"
      ></Hero>
    </div>

    <div class="section">
      <ArticleRenderer :project="project"></ArticleRenderer>
    </div>
  </div>
</template>

<script>
  import 'intersection-observer' // for cross-browser support

  import Hero from '@/components/Hero.vue'
  import HeadlineWithLine from '@/components/typography/HeadlineWithLine';
  import ArticleRenderer from '@/components/ArticleRenderer.vue'

  import { mapState } from 'vuex' 


  export default {
    components: {
      Hero,
      HeadlineWithLine,
      ArticleRenderer
    },
    data() {
      return {
        project: null
      }
    },
    computed: {
      ...mapState(['projects'])
    },
    watch: {
      projects: {
        handler: function () {
          if(this.projects.length > 0) {
            this.projects.forEach(element => {
              if(element.id == 'YY0woBAAACIAn_Qs') {
                this.project = element
              } else {
                console.log("Project could not be found in Projects Array — please check ID")
              }
            });
          }
        },
        immediate: true
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  
</style>

<style lang="scss">
  @import '../../assets/scss/base.scss';

  intro,
  .outro {
    padding: 20vh;
  }

  .hero {
    max-width: 100vw;

    &>img {
      width: 100%;
    }
  }

  #port-box-top {
    background: #26353D;
  }

  #klimagrafik-abstract {
    background: #F7FCFF;
  }

  #port-mega {
    background: rgb(20, 29, 35);
    background: linear-gradient(180deg, rgba(20, 29, 35, 1) 0%, rgba(6, 5, 6, 1) 100%);
  }

  .graphic {
    height: 100vh;
    background-color: #eee;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .scrollytell-image {
    position: absolute;
    object-fit: contain;

    &.top {
      z-index: 10;
    }

    @include lg() {
      width: 150% !important;
      left: 0
    }
  }

  .step {
    padding: 15vh 0;
    width: 50%;
    margin: 0 auto 30vh;
    display: flex;
  }

  .box {
    img {
      position: relative;
      bottom: 0;
      width: 100%;
      max-width: inherit;
    }
  }

  .video {
    width: 1280px;
    border-radius: 4px;
    background: $port-background;
  }

  .ipad {
    position: relative;
    .ipad-device {
      z-index: 10;
    }
    .ipad-frontend {
      width: 25% !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-60%);
      z-index: -1;
    }
  }

  
</style>